module.exports = __webpack_public_path__ + "media/img/delete-cafb1233e2036c6ea6f44c9b97fcf680.gif";